export default "__VITE_ASSET__8dc707b8__"